import { Switch as FluentSwitch } from "@fluentui/web-components";
/**
 * Switch
 * @summary A Fabric UI Switch component that extends Fluent UI's Switch with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-switch checked>
 *   <span slot="switch">Toggle</span>
 * </fabric-switch>
 * ```
 *
 * @attr {boolean | undefined} autofocus - Indicates that the element should get focus after the page finishes loading.
 * @attr {boolean | undefined} disabled - The disabled state of the control.
 * @attr {string | undefined} form - The id of a form to associate the element to.
 * @attr {boolean | undefined} checked - The initial checked state of the element.
 * @attr {string | undefined} value - The initial value of the input.
 * @attr {boolean | undefined} required - The required state of the element.
 * @attr {string | undefined} name - The name of the element. This element's value will be surfaced during form submission under the provided name.
 *
 * @prop {boolean} autofocus - Indicates that the element should get focus after the page finishes loading.
 * @prop {boolean} disabled - The disabled state of the control.
 * @prop {string} form - The id of a form to associate the element to.
 * @prop {boolean} checked - The initial checked state of the element.
 * @prop {boolean} required - The required state of the element.
 * @prop {string} value - The initial value of the input.
 * @prop {string} name - The name of the element. This element's value will be surfaced during form submission under the provided name.
 *
 * @slot switch - Custom slot for the switch indicator.
 *
 * @csspart checked-indicator - The part representing the checked state indicator.
 *
 * @method checkValidity - Checks the validity of the element and returns the result.
 * @method reportValidity - Reports the validity of the element.
 * @method setCustomValidity - Sets a custom validity message with the provided message.
 * @method toggleChecked - Toggles the checked state of the control, with an optional force parameter.
 *
 * @extends FluentSwitch
 * @tagname fabric-switch
 * @public
 */
export class Switch extends FluentSwitch {
}
//# sourceMappingURL=switch.js.map